import React from "react";
import { Button, Badge } from "react-bootstrap";
import moment from "moment";

const ProjectCommercialsTab = ({
  // Data
  commercials,
  commercialsLoading,

  // Permissions
  hasProjectAdminRole,
  hasProjectManagerRole,

  // Handlers
  handleCreateCommercial,
  handleEditCommercial,
  formatCurrencyDisplay,
}) => {
  const canEdit = hasProjectAdminRole() || hasProjectManagerRole();

  return (
    <div className="project-view-fade-in">
      <div className="project-overview-single-card">
        <div className="d-flex justify-content-between align-items-center mb-4">
          {canEdit && (
            <Button variant="primary" onClick={handleCreateCommercial}>
              Add Commercial
            </Button>
          )}
        </div>

        {commercialsLoading ? (
          <div className="text-center py-4">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading commercials...</span>
            </div>
          </div>
        ) : commercials.length === 0 ? (
          <div className="text-center py-5 text-muted">
            <i className="fas fa-chart-line fa-3x mb-3"></i>
            <h5>No Commercials Found</h5>
            <p className="mb-4">
              No commercial information is available for this project yet.
            </p>
            {canEdit && (
              <Button
                variant="outline-primary"
                onClick={handleCreateCommercial}
              >
                Add Your First Commercial
              </Button>
            )}
          </div>
        ) : (
          <div className="table-responsive">
            <table className="project-view-commercial-table">
              <thead className="project-view-commercial-table-header">
                <tr>
                  <th>Commercial ID</th>
                  <th>Title</th>
                  <th>Description</th>
                  <th>Planned Revenue</th>
                  <th>Type</th>
                  <th>Currency</th>
                  <th>Created By</th>
                  <th>Created Date</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody className="project-view-commercial-table-body">
                {commercials.map((commercial) => (
                  <tr
                    key={commercial.commercialId}
                    className="commercial-table-row"
                  >
                    <td className="commercial-id-cell">
                      <div className="commercial-id">
                        {commercial.commercialId}
                      </div>
                    </td>
                    <td className="commercial-title-cell">
                      <div className="commercial-title">
                        {commercial.commercialTitle}
                      </div>
                    </td>
                    <td className="commercial-description-cell">
                      <div className="commercial-description">
                        {commercial.commercialDescription || "-"}
                      </div>
                    </td>
                    <td className="commercial-revenue-cell">
                      <div className="commercial-revenue">
                        {formatCurrencyDisplay(
                          commercial.commercialPlannedRevenue,
                          commercial.commercialCurrency,
                        )}
                      </div>
                    </td>
                    <td className="commercial-type-cell">
                      <div className="commercial-type">
                        {commercial.commercialType || "-"}
                      </div>
                    </td>
                    <td className="commercial-currency-cell">
                      <div className="commercial-currency">
                        {commercial.commercialCurrency || "-"}
                      </div>
                    </td>
                    <td className="commercial-createdby-cell">
                      <div className="commercial-createdby">
                        {commercial.createdBy || "-"}
                      </div>
                    </td>
                    <td className="commercial-date-cell">
                      {commercial.createdOnDate
                        ? moment(commercial.createdOnDate).format(
                            "MMM DD, YYYY",
                          )
                        : "-"}
                    </td>
                    <td className="commercial-actions-cell">
                      <div className="commercial-actions">
                        {canEdit && (
                          <Button
                            variant="outline-primary"
                            size="sm"
                            onClick={() => handleEditCommercial(commercial)}
                            className="me-2"
                            title="Edit Commercial"
                            style={{ padding: "6px" }}
                          >
                            Edit
                          </Button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectCommercialsTab;
